export enum ModalActions {

    HANDLE_MODAL = 'HANDLE_MODAL',
    HANDLE_SETTINGS_MODAL = 'HANDLE_SETTINGS_MODAL',
    HANDLE_LOGIN_MODAL = 'HANDLE_LOGIN_MODAL'

}



// WEBPACK FOOTER //
// ./src/constants/modalActions.ts